import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, BehaviorSubject, Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private showPreview = new Subject<{showPreview: string}>();
  private isLandscape = new Subject<{isLandscape: boolean}>();
  private deviceWidth = new Subject<{deviceWidth: number}>();

  constructor(
    private httpClient: HttpClient
  ) {

  }

  // Public Methods
  // --------------------------

  // Camera Preview
  showComponentPreview(showPreview: string) {
      this.showPreview.next({ showPreview });
  }

  clearPreview() {
      this.showPreview.next(void 0);
  }

  getPreview(): Observable<any> {
      return this.showPreview.asObservable();
  }

  // Orientation Status
  updateOrientation(isLandscape: boolean) {
      this.isLandscape.next({ isLandscape });
  }

  clearOrientation() {
      this.isLandscape.next({isLandscape: false});
  }

  getOrientation() {
      return this.isLandscape.asObservable();
  }

  // Device status
  updateDeviceWidth(deviceWidth: number) {
      this.deviceWidth.next({ deviceWidth });
  }

  clearDeviceWidth() {
      this.deviceWidth.next(void 0);
  }

  getDeviceWidth() {
      return this.deviceWidth.asObservable();
  }

  // End of Public Methods
  // --------------------------

  public getApp(id): Observable<any> {
    return this.httpClient.get<any>(`/api/v2/classhive/apps/`+id)
      .pipe(
        map(data => {
         return data.result
        })
      )
  }


}
